module.exports = __webpack_public_path__ + "media/v2/icon_layer-91dd0f10.svg";